import React, { Component } from "react";
import { connect } from "react-redux";
import CreateTable from "../../CreateTable";
import Loader from "../../Loader";

class CommodityBreakdownTable extends Component {
  state = {
    categoryRows: {
      commodityVariety: { name: "", cell: 1 },
      inventory: { name: "Farm Inventory", cell: 2 },
      contracted: { name: "", cell: 1 },
      deliveredBushels: { name: "Estimated Delivered Bushels", cell: 2 },
      reconciledBushels: { name: "Reconciled Delivered Bushels", cell: 2 }
    },
    headerRows: {
      commodityVariety: "Commodity Variety",
      inventoryUsingEstBushels: "Using Estimated Bushels",
      inventoryUsingReconciledBushels: "Using Reconciled Bushels",
      bushelsContracted: "Bushels Contracted",
      ...this.props.dynamicCols
    },
    order: "desc",
    orderBy: ""
  };

  handleRequestSort = (event, property) => {
    const isDesc =
      this.state.orderBy === property && this.state.order === "desc";
    this.setState({
      order: isDesc ? "asc" : "desc",
      orderBy: property
    });
  };
  render() {
    const { commodityList = [], fetchingComplete, ErrorMessage } = this.props;
    const { incomingFillOption, outgoingFillOption } = this.props;
    const { headerRows, order, orderBy, categoryRows } = this.state;
    const computedList = [...commodityList];
    computedList.map(item => {
      item.inventoryUsingEstBushels =
        item[incomingFillOption] - item[outgoingFillOption];
      item.inventoryUsingReconciledBushels =
        item[incomingFillOption] - item.payloadDelivered;

      item.inventoryUsingEstBushels = parseFloat(
        item.inventoryUsingEstBushels || 0
      ).toFixed(2);
      item.inventoryUsingReconciledBushels = parseFloat(
        item.inventoryUsingReconciledBushels || 0
      ).toFixed(2);
    });
    return (
      <div className="">
        {fetchingComplete ? (
          ErrorMessage && ErrorMessage.message ? (
            <div className="ErrorMessage">{ErrorMessage.message}</div>
          ) : (
            <CreateTable
              categoryRows={categoryRows}
              headerRows={headerRows}
              rowData={computedList}
              isMenuRequired={false}
              order={order}
              orderBy={orderBy}
              isBorder
              onRequestSort={this.handleRequestSort}
            />
          )
        ) : (
          <Loader />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    commodityList: state.selectedCommodityReducer.commodityData,
    fetchingComplete: state.selectedCommodityReducer.fetchingComplete,
    ErrorMessage: state.globalserverMessage.ErrorMessage
  };
}

export default connect(mapStateToProps)(CommodityBreakdownTable);



// WEBPACK FOOTER //
// ./src/components/private/Dashboard/CommodityBreakdownTable.js